import {match, Pattern} from 'ts-pattern';

import type {MinipurchaseResponseBody, TestDriveSlotRequestBody} from '@dms/api/finance';

type TestDriveSlotSource = Pick<
  MinipurchaseResponseBody,
  'testDriveScheduledAt' | 'testDriveRequestedDate'
>;

/**
 * Maps the mutually exclusive response pair (instant or day only) back to the
 * request slot, so a PUT rebuilt from the response does not wipe a date-only slot.
 */
export const toTestDriveSlotRequestBody = (
  minipurchase: TestDriveSlotSource
): TestDriveSlotRequestBody | null =>
  match(minipurchase)
    .with({testDriveScheduledAt: Pattern.string}, ({testDriveScheduledAt}) => testDriveScheduledAt)
    .with({testDriveRequestedDate: Pattern.string}, ({testDriveRequestedDate}) => ({
      date: testDriveRequestedDate,
    }))
    .otherwise(() => null);
